import React, {useContext} from "react";
import {
  Box,
  Button, Divider, FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  Tooltip,
  Typography
} from "@mui/material";
import {menuItemsInfo} from "../editMenuItems";
import {IconX} from "@tabler/icons-react";
import {NodeType} from "../../../../../model/ModelData";
import {WebSettingsContext} from "../../../../../context/WebSettingsContext";

export const GreetMessageTab = ({node, setNode, onUpdate}) => {
  const {settings} = useContext(WebSettingsContext);

  const onChangeMessage = async (index, value) => {
    const state = {...node}
    if (state.data.greet[index] !== value) {
      state.data.greet[index] = value;
      setNode(state)
    }
  }
  const onUpdateMessage = async () => {
    await onUpdate(node);
  }

  const removeGreetMessage = async (index) => {
    const state = {...node}
    state.data.greet = state.data.greet?.filter((greet, ind) => ind !== index);
    await onUpdate(state);
  }

  const addGreetMessage = async () => {
    const state = {...node}
    if (state?.data?.greet?.length === 0) {
      state.data.greet = []
    }
    state.data.greet = [...state.data.greet, ""];

    await onUpdate(state);
  }

  const {primary, secondary} = menuItemsInfo.greet;

  const audios = settings?.audios || []
  const selectedAudio = audios?.find(i => i?.path === node?.data?.please_wait_message)?.path || null;

  return (
    <>
      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>{primary}</Typography>
        <Typography variant={"body2"} fontSize={13}>{secondary}</Typography>
      </Box>
      {
        node?.data?.greet?.map((greet, index) => {
          return <Stack direction={"row"} gap={1} sx={{position: "relative"}}>
            <TextField
              value={greet}
              size={"small"}
              placeholder={"Write here message..."}
              sx={{flex: 1}} multiline={true} minRows={3} maxRows={5}
              onChange={e => onChangeMessage(index, e.target.value)}
              onBlur={e => onUpdateMessage(index, e.target.value)}
            />
            <Tooltip title={"Delete Message"}>
              <IconButton
                sx={{
                  border: 0.5, borderColor: "rgba(48,148,213,0.6)",
                  p: 0.5, color: "info.main", borderRadius: "50% !important",
                  position: "absolute", top: 3, right: 3,
                  // transform: "translate(10%, -10%)"
                }}
                onClick={() => removeGreetMessage(index)}
              >
                <IconX size={14} />
              </IconButton>
            </Tooltip>
          </Stack>
        })
      }

      <Button
        variant={"modal"}
        color={"secondary"}
        onClick={addGreetMessage}
      >
        Add new message
      </Button>

      <Box sx={{borderBottom: 1, borderColor: "divider", pb: 0.5}}>
        <Typography fontWeight={700} sx={{pb: 1}}>Please Wait Message</Typography>
        <Typography variant={"body2"} fontSize={13}>Enter message agent can send to the user while waiting for response</Typography>
      </Box>
      <TextField
        value={!!selectedAudio ? "" : node?.data?.please_wait_message || ""}
        size={"small"}
        // disabled={!!selectedAudio}
        placeholder={"Write here wait message..."}
        multiline={true} minRows={3} maxRows={5}
        onChange={e => setNode(prev => ({...prev, data: {...(prev?.data || {}), please_wait_message: e.target.value}}))}
        onBlur={e => onUpdateMessage()}
      />
      <Divider>OR</Divider>
      <FormControl size={"small"}>
        <InputLabel id={`audio-label`}
                    sx={{textTransform: "capitalize"}}>Audio</InputLabel>
        <Select
          labelId={`audio-label`}
          id={`audio-select`}
          value={selectedAudio || "none"}
          label={`Audio`}
          onChange={e => setNode(prev => ({...prev, data: {...(prev?.data || {}), please_wait_message: e.target.value}}))}
          onBlur={e => onUpdateMessage()}
        >
          <MenuItem value={"none"}><em>{selectedAudio ? "None" : "--Select Audio--"}</em></MenuItem>
          {audios?.map(audio => {
            return (
              <MenuItem key={audio?.path} value={audio?.path}>{audio?.name}</MenuItem>
            )
          })}
        </Select>
      </FormControl>

    </>
  )
}